/** Render **For-Me** as bold. Escapes the rest so slide text cannot inject HTML. */
export function inlineBold(text) {
  const escaped = String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
  return escaped.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
}
